module.exports = __webpack_public_path__ + "media/zzcg.a2ea443d.mp4";